type ConnectionRecord = {
  status?: string;
  connectionEnabled?: boolean;
  deviceSecretHash?: string;
  lastSeenAt?: { toDate?: () => Date; toMillis?: () => number } | null;
};

export function stationIsConnected(item: ConnectionRecord) {
  return item.status === "APPROVED" && item.connectionEnabled !== false && Boolean(item.deviceSecretHash);
}

export function stationCanDrop(item: ConnectionRecord) {
  return item.status === "APPROVED" && item.connectionEnabled !== false && Boolean(item.deviceSecretHash);
}

export function stationConnectionText(item: ConnectionRecord) {
  return stationIsConnected(item) ? "Connected" : "Not connected";
}
